import { SiteSearchCategory } from '../site-search-category';
import { ContentIntro } from './intro';

/**
 * Model definition for SiteSearch
 */
export interface ContentSiteSearch {
  __component: 'content.site-search';
  id: string;
  placeholder: string;
  categories?: SiteSearchCategory[];
  intro?: ContentIntro;
}

export function isContentSiteSearch(obj: { __component?: string }): obj is ContentSiteSearch {
  return obj.__component === 'content.site-search';
}
